import {Injectable} from "@angular/core";
import {IProductLine} from "../cart/cart-models";
import {OrderProductInput} from "../../checkout/models/order/order";
import {AnalyticsService} from "./analytics.service";
import * as _ from "lodash";

@Injectable({
    providedIn: 'root'
})
export class AnalyticsHelperService {

    constructor(private analyticsService: AnalyticsService) {}

    getUpsellProductLines(inputs: OrderProductInput[], cartProducts: IProductLine[]): IProductLine[] {
        return _.filter(cartProducts ?? [], (pl: IProductLine) =>
            inputs.some((inp: OrderProductInput) => inp.productId === pl.product.usanaId)
        );
    }

    diffAndFireUpsellEvents(prev: OrderProductInput[], current: OrderProductInput[], cartProducts: IProductLine[]): void {
        current.forEach((currProd: OrderProductInput) => {
            const prevQty = prev.find((p: OrderProductInput) => p.productId === currProd.productId)?.quantity ?? 0;
            const delta = currProd.quantity - prevQty;
            if (delta !== 0) {
                const pl = cartProducts?.find((p: IProductLine) => p.product.usanaId === currProd.productId);
                if (pl) {
                    const itemPrice = pl.product.aoPrice?.price ?? pl.product.price?.price ?? 0;
                    if (delta > 0) {
                        this.analyticsService.upsellSubscriptionAddEvent(pl.product, delta, itemPrice * delta);
                    } else {
                        this.analyticsService.upsellSubscriptionRemoveEvent(pl.product, Math.abs(delta), itemPrice * Math.abs(delta));
                    }
                }
            }
        });
        prev.forEach((prevProd: OrderProductInput) => {
            if (!current.find((c: OrderProductInput) => c.productId === prevProd.productId)) {
                const pl = cartProducts?.find((p: IProductLine) => p.product.usanaId === prevProd.productId);
                if (pl) {
                    const itemPrice = pl.product.aoPrice?.price ?? pl.product.price?.price ?? 0;
                    this.analyticsService.upsellSubscriptionRemoveEvent(pl.product, prevProd.quantity, itemPrice * prevProd.quantity);
                }
            }
        });
    }
}
